import React, {useState} from "react";
import {withRouter} from "react-router-dom";
import emailjs from 'emailjs-com';
import Reveal from 'react-reveal/Reveal';

import SimpleMap from '../components/Map';
import Footer from '../components/Footer';

import {Efect, Efect1, Efect2} from "../styles/effect.styles";


const Contact = ({history}) => {
    const [inputs, setInputs] = useState({
        name: '',
        email: '',
        message: '',
    });
    function sendEmail(e) {
        const success = document.getElementById("success");
        const button = document.getElementById("buttonsent");
        const failed = document.getElementById("failed");
        e.preventDefault();
        let text = '';
        text = "Message from web site:%0A" +
            inputs.name + "%0A" +
            inputs.email + "%0A" +
            inputs.message + "%0A";

        console.log(inputs)
        fetch('https://api.telegram.org/bot1876105003:AAFFOCArseSYvYyDDT30K1TzgYGviK38O6w/sendMessage?chat_id=1798065957&text=' + text, {})
            .then(response => response.json())
            .then(data => {
                success.classList.add('show');
                button.classList.add('show');
                failed.classList.remove('show');
            })
            .catch(err => failed.classList.add('show'))
        fetch('https://api.telegram.org/bot1876105003:AAFFOCArseSYvYyDDT30K1TzgYGviK38O6w/sendMessage?chat_id=1835687997&text=' + text, {})
            .then(response => response.json())
            .then(data => {
                success.classList.add('show');
                button.classList.add('show');
                failed.classList.remove('show');
            })
            .catch(err => failed.classList.add('show'))
        // emailjs.sendForm('gmail', 'template_csfdEZiA', e.target, 'user_zu7p2b3lDibMCDutH5hif')
        //     .then((result) => {
        //         console.log(result.text);
        //         success.classList.add('show');
        //         button.classList.add('show');
        //         failed.classList.remove('show');
        //     }, (error) => {
        //         console.log(error.text);
        //         failed.classList.add('show');
        //     });
    }
    const handle = (e, type) => {
        switch (type) {
            case 'name':
                setInputs({...inputs, name: e.target.value})
                return;
            case 'email':
                setInputs({...inputs, email: e.target.value})
                return;
            case 'message':
                setInputs({...inputs, message: e.target.value})
                return;
            default:
                return;
        }
    };

    return (
        <div>
            <Efect/>
            <Efect1/>
            <Efect2/>

            <div className="jumbotron head"/>

            <Reveal effect="fadeInUp">
                <section className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <h1>Get in touch with us to earn <br/>money on <span className='color'>pornhub</span></h1>
                        </div>
                    </div>
                </section>
            </Reveal>

            <Reveal effect="fadeInUp">
                <section className='container pt-0'>
                    <div className='row'>
                        <div className='col-12'>
                            {/*<SimpleMap/>*/}
                        </div>
                        <div className='col-md-6'>
                            <div className="text-side">
                                <h3 className="heading">Talk with our expert </h3>
                                {/*<p>Vestibulum volutpat, lacus a ultrices sagittis, */}
                                {/*mi neque euismod dui, eu pulvinar nunc sapien ornare nisl. <br/>*/}
                                {/*Phasellus pede arcu, dapibus eu, fermentum et, */}
                                {/*dapibus sed, urna.</p>*/}
                                <div className='address'>
                                    <div className='heading'>Our Office</div>
                                    <div className='list'>
                                        <i className="fa fa-map-marker"></i>
                                        Sankt Paulsgatan, 118 48 Stockholm, Sweden
                                    </div>
                                    <div className='list'>
                                        <i className="fa fa-envelope-o"></i>
                                        <a href='mailto:btom07459@gmail.com' target='_blank' rel='noopener noreferrer'>
                                            btom07459@gmail.com
                                        </a>
                                    </div>
                                    <div className='list'>
                                        <i className="fa fa-phone"></i>
                                        <span className={""}><a href="https://t.me/tomasbrown">Telegram: @tomasbrown</a></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="form-side">
                                <form className="formcontact" onSubmit={sendEmail}>
                                    <label>Name</label>
                                    <input type="text" name="user_name" onChange={(e) => handle(e, 'name')} required/>
                                    <label>Email</label>
                                    <input type="email" name="user_email" onChange={(e) => handle(e, 'email')} required/>
                                    <label>Message</label>
                                    <textarea name="message" onChange={(e) => handle(e, 'message')} required/>
                                    <div id='success' className='hide'>Your message has been sent...</div>
                                    <div id='failed' className='hide'>Message failed...</div>
                                    <button type="submit" id='buttonsent'>
                                        <span className="shine"></span>
                                        <span>Send</span>
                                    </button>
                                </form>
                            </div>
                        </div>


                    </div>
                </section>
            </Reveal>


            <Footer/>

        </div>

    );
};

export default withRouter(Contact);
